module.exports = __webpack_public_path__ + "static/media/number-item-7.e421177d.png";